import { render, staticRenderFns } from "./serviceitem.vue?vue&type=template&id=05ab648a&scoped=true"
import script from "./serviceitem.vue?vue&type=script&lang=js"
export * from "./serviceitem.vue?vue&type=script&lang=js"
import style0 from "./serviceitem.vue?vue&type=style&index=0&id=05ab648a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab648a",
  null
  
)

export default component.exports